"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAisleWeight = resetAisleWeight;
async function resetAisleWeight(machineRepo, machineId, aisleCode) {
    return await machineRepo.resetAisleWeight(machineId, aisleCode);
}
